import { defaultDFKProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/defi-kingdoms/default-constants';

export const TRADER_DFK_CONTRACT_ADDRESS = '0x3C351E1afdd1b1BC44e931E12D4E05D6125eaeCa';

export const TRADER_DFK_PROVIDER_CONFIGURATION = defaultDFKProviderConfiguration;
